const PROTOCOL_RELATIVE_URL = /^\/\//;
const NON_TRANSFORMING_ASSET_HOST =
  /^https:\/\/(?:downloads|assets)\.ctfassets\.net\//;
const TRANSFORMING_ASSET_HOST = 'https://images.ctfassets.net/';

const toHttpsUrl = (url) => {
  return typeof url === 'string' && PROTOCOL_RELATIVE_URL.test(url)
    ? `https:${url}`
    : url;
};

const toTransformingHost = (url, contentType) => {
  return typeof url === 'string' &&
    typeof contentType === 'string' &&
    contentType.startsWith('image/')
    ? url.replace(NON_TRANSFORMING_ASSET_HOST, TRANSFORMING_ASSET_HOST)
    : url;
};

const normalizeAssetUrls = (value, seen, rewriteImageHosts) => {
  if (Array.isArray(value)) {
    value.forEach((item) => {
      normalizeAssetUrls(item, seen, rewriteImageHosts);
    });
    return value;
  }

  if (value === null || typeof value !== 'object' || seen.has(value)) {
    return value;
  }
  seen.add(value);

  const { file } = value;
  if (file !== null && typeof file === 'object') {
    const httpsUrl = toHttpsUrl(file.url);
    const url = rewriteImageHosts
      ? toTransformingHost(httpsUrl, file.contentType)
      : httpsUrl;
    if (url !== file.url) {
      file.url = url;
    }
  }

  Object.keys(value).forEach((key) => {
    normalizeAssetUrls(value[key], seen, rewriteImageHosts);
  });

  return value;
};

const wrapMethod = (client, method, rewriteImageHosts) => {
  return async (...args) => {
    return normalizeAssetUrls(
      await client[method](...args),
      new WeakSet(),
      rewriteImageHosts,
    );
  };
};

export const withHttpsAssetUrls = (
  client,
  { rewriteImageHosts = false } = {},
) => {
  const wrapped = Object.create(client);
  wrapped.getEntries = wrapMethod(client, 'getEntries', rewriteImageHosts);
  wrapped.getEntry = wrapMethod(client, 'getEntry', rewriteImageHosts);
  return wrapped;
};
